module.exports = __webpack_public_path__ + "media/mixed hemorrhoid.c3436a48.wav";